export const normalizePartnerReferralFilterApiResponse = (res) => {
  const isSuccess = res?.isSuccess ?? res?.IsSuccess;
  if (isSuccess === false) {
    return { isSuccess: false, data: [], message: res?.message ?? res?.Message };
  }

  const list = res?.data ?? res?.Data ?? [];
  if (!Array.isArray(list)) {
    return { isSuccess: true, data: [] };
  }

  return {
    isSuccess: true,
    data: list
      .map((item) => ({
        partnerId: item?.partnerId ?? item?.PartnerId,
        displayName: (item?.displayName ?? item?.DisplayName ?? "").trim(),
      }))
      .filter((item) => item.partnerId != null && item.displayName),
    message: res?.message ?? res?.Message,
  };
};
